import React from 'react';

type TrackingStudentProps = {
  firstName: string;
  lastName: string;
  checkInTime: number;
  sessionTime: number;
  yellowTime: number;
  redTime: number;
};
const TrackingStudent = ({
  firstName,
  lastName,
  checkInTime,
  sessionTime,
  yellowTime,
  redTime,
}: TrackingStudentProps) => {
  const parseDate = () => {
    const dateObj = new Date(checkInTime);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    let hourString;
    if (hours < 10) {
      hourString = `0${hours}`;
    } else if (hours > 12) {
      hourString = `${hours - 12}`;
    } else {
      hourString = `${hours}`;
    }
    return `${hourString}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
  };

  const getRemainingTime = () => {
    const elapsedTime = Date.now() - checkInTime;
    const elapsedMinutes = elapsedTime / (1000 * 60);
    return sessionTime - elapsedMinutes;
  };

  const getElapsedTime = () => {
    const elapsedTime = Date.now() - checkInTime;
    let simplified = elapsedTime / 1000;
    if (simplified < 60) {
      return `${Math.round(simplified)} second${Math.round(simplified) === 1 ? '' : 's'}`;
    }
    simplified /= 60;

    if (simplified < 60) {
      return `${Math.round(simplified)} minute${Math.round(simplified) === 1 ? '' : 's'}`;
    }

    const hours = Math.floor(simplified / 60);
    simplified -= hours * 60;
    return `${hours} hour${hours === 1 ? '' : 's'}, ${Math.round(simplified)} minute${Math.round(simplified) === 1 ? '' : 's'}`;
  };

  const getColour = () => {
    const remainingMinutes = getRemainingTime();
    if (remainingMinutes <= redTime) {
      return 'bg-red-400';
    } else if (remainingMinutes <= yellowTime) {
      return 'bg-amber-500';
    }
    return 'bg-white';
  };

  return (
    <div
      className={`border overflow-hidden mb-4 p-8 rounded-2xl flex flex-col items-center bg-white`}
    >
      <div className="font-bold text-4xl">{`${firstName} ${lastName.charAt(0)}.`}</div>
      <div className={`text-2xl  ${getColour()} w-full`}>{parseDate()}</div>
      <div className={`text-2xl  ${getColour()} w-full`}>{getElapsedTime()}</div>
    </div>
  );
};

export default TrackingStudent;
